{
	"actions_of": "Actions for application {{protocol}}",
	"check_in": "Moved in on {{date}}",
	"check_in_command": {
		"action": "Confirm the move-in",
		"before_proposal": "The date cannot be before the room was proposed.",
		"blocked": {
			"offer_not_accepted": "The offer is no longer accepted.",
			"room_not_proposed": "Propose the room first.",
			"verification_not_compliant": "The verification of the documents must be compliant first."
		},
		"confirm": "Confirm",
		"date": "Moved in on",
		"description": "The day the student moved into the room proposed. The move-in also counts for the DSU quota.",
		"done": "Move-in confirmed.",
		"future": "The date cannot be in the future.",
		"title": "Confirm the move-in"
	},
	"columns": {
		"actions": "Actions",
		"check_in": "Moved in",
		"name": "Student",
		"preference": "Preference",
		"protocol": "Protocol",
		"quota": "Quota",
		"room": "Room",
		"verification": "Verification"
	},
	"counts": {
		"double": "Doubles",
		"equipped": "of which equipped {{used}} of {{total}}",
		"quota": {
			"q30": "30% quota",
			"q70": "70% quota"
		},
		"single": "Singles",
		"sites": "Sites",
		"title": "Beds",
		"used": "{{used}} of {{total}}"
	},
	"empty": "Nobody has accepted an offer yet.",
	"empty_filtered": "Nobody in this state.",
	"equipped_priority": "Equipped seat, with the priority for a disability",
	"error": "The arrivals could not be loaded. Reload the page.",
	"fact": {
		"action": "Record a fact",
		"cause": "Fact",
		"confirm": "Record",
		"contract_hint": "Only before the move-in: whoever moved in signed the contract.",
		"date": "Day of the fact",
		"description": "The seat is free again and goes to the next one in the ranking, and the student gets an email with the cause. The fact is not annulled.",
		"done": "Fact recorded: the seat goes to the next one.",
		"line": "{{cause}}, on {{date}}",
		"note": "Note",
		"note_hint": "Optional.",
		"out_of_range": "The date can be neither in the future nor before the acceptance.",
		"proof_hint": "The student's message, or the proof that the term ran out.",
		"title": "Record a fact after the acceptance"
	},
	"filter": "State",
	"intro": "Everyone who accepted an offer, from the check of their documents to the move-in: open the verification from the name, then propose the room and the site and record the move-in. The system keeps count of the beds of each quota and site.",
	"limit": {
		"equipped_required": "The seat was given with the priority for a disability: it needs an equipped room.",
		"equipped_reserved": "The equipped rooms left are held for the students with the priority of a disability who have no room yet.",
		"quota": "The {{quota}} has no {{type}} rooms free: there are {{available}} in all.",
		"site": "The site {{site}} has no {{type}} rooms free.",
		"site_equipped": "The site {{site}} has no equipped {{type}} rooms free.",
		"site_ordinary": "The {{site}} site has no {{type}} non-equipped room left: there are {{available}} in all. Choose «Equipped room» or another site."
	},
	"not_given": "Not given",
	"page_title": "Arrivals",
	"preference": {
		"double": "Double",
		"none": "No preference",
		"single": "Single"
	},
	"propose": {
		"action": "Propose a room",
		"again": "Change the room",
		"confirm": "Propose",
		"description": "The student gets an email with the room, the site and how to sign the contract.",
		"done": "Room proposed: the student gets the email.",
		"equipped": "Equipped room",
		"equipped_free": "Equipped free at the site: {{free}}",
		"equipped_required": "Required: the seat was given with the priority for a disability.",
		"free": "Free: {{quotaFree}} in the {{quota}}, {{siteFree}} at the site",
		"preference_differs": "The student preferred: {{preference}}. You can still propose this room.",
		"room_type": "Type of room",
		"site": "Site",
		"title": "Propose the room and the site"
	},
	"quota": {
		"q30": "30% quota",
		"q70": "70% quota"
	},
	"quota_inline": {
		"q30": "30% quota",
		"q70": "70% quota"
	},
	"room": {
		"double": "Double room",
		"equipped": "equipped",
		"none": "To propose",
		"single": "Single room"
	},
	"search_placeholder": "Search by protocol or name",
	"state": {
		"checked_in": "Moved in",
		"forfeited": "Forfeited",
		"room_proposed": "Room proposed",
		"to_propose": "To propose"
	},
	"type_plural": {
		"double": "double",
		"single": "single"
	},
	"verification": {
		"compliant": "Compliant",
		"excluded": "Excluded",
		"none": "Not opened",
		"pending": "Pending",
		"to_check": "To check: {{items}}"
	},
	"verification_filter": "Verification"
}
